export default "__VITE_ASSET__B8WC53Hd__"